import Lightbox from '../utils/_lightbox'

var $ = jQuery

export default class SidebarWithTableOfContents {

  ready () {
    this.initLightbox();

    this.initSidebarClick();

    const CONTAINER = document.querySelector('.mtt-template-content__content')
    if (CONTAINER) {
      this.init(CONTAINER)
    }
  }

  initLightbox() {
    $(document).ready(function($) {
      $('body.page-template-with-table-of-contents .mtt-template-content__content-wrapper table').each(function() {
        $(this).wrap('<div class="custom-table-wrapper"></div>');
      });
    });

    new Lightbox(document.querySelectorAll('body.page-template-with-table-of-contents .mtt-template-content__content-wrapper .mtt-template-content__wysiwyg-content img'))
  }

  initSidebarClick() {
    $(document).on('click', '.mtt-template-content__sidebar--list ul li a', (e) => {
      this.closeModal()
    });
  }

  init(CONTAINER) {
    this.CONTAINER = CONTAINER
    this.WRAPPER = this.CONTAINER.querySelector('.mtt-template-content__sidebar-wrapper')
    this.OPENBUTTON = this.CONTAINER.querySelector('.mtt-template-content__sidebar-button--open')
    this.CLOSEBUTTON = this.CONTAINER.querySelector('.mtt-template-content__sidebar-button--close')

    if (this.OPENBUTTON) {
      this.OPENBUTTON.addEventListener('click', () => {
        this.openModal()
      })
    }

    if (this.CLOSEBUTTON) {
      this.CLOSEBUTTON.addEventListener('click', () => {
        this.closeModal()
      })
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeModal()
      }
    })
  }

  openModal(){
    this.WRAPPER.classList.add('active')
    document.body.classList.add('overflow-hidden')
  }

  closeModal(){
    this.WRAPPER.classList.remove('active')
    document.body.classList.remove('overflow-hidden')
  }
}